import { defineMessages } from "react-intl";

const messages = defineMessages({
    title1: {
        id: "intro.melodyTable.1.title",
    },
    title3: {
        id: "intro.melodyTable.3.title",
    },
    title4: {
        id: "intro.melodyTable.4.title",
    },
    description1: {
        id: "intro.melodyTable.1.description",
    },
    description3: {
        id: "intro.melodyTable.3.description",
    },
    description4: {
        id: "intro.melodyTable.4.description",
    },
});

export default messages;
